const getUTMs = (
  queryParams: URLSearchParams,
): Record<string, string | null> => {
  return {
    campaign_id: queryParams.get('utm_campaign'),
    ad_id: queryParams.get('utm_content'),
    source: queryParams.get('utm_source'),
    medium: queryParams.get('utm_medium'),
    term: queryParams.get('utm_term'),
    ad_name: queryParams.get('utm_ad_name'),
    campaign_name: queryParams.get('utm_campaign_name'),
    adset_name: queryParams.get('utm_adset_name'),
    adset_id: queryParams.get('utm_adset_id'),
    placement: queryParams.get('utm_placement'),
    network: queryParams.get('utm_network'),
    matchtype: queryParams.get('utm_matchtype'),
  };
};

export default getUTMs;
